module.exports = __webpack_public_path__ + "5ed5cfe9691ab8b7b9f1f2495fe2b781.svg";